<template>
    <admin-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-white leading-tight">
                Clienti senza QR Code
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div id="student-table" class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <TableStudents :rows="students" />
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import TableStudents from '@/Components/TableStudents'

    export default {
        props: ["students"],
        components: {
            AdminLayout,
            TableStudents,
        },
    }
</script>